import React, {useEffect} from 'react';
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

const DispatchNatures = ({data}) => {

  useEffect(() => {
    const values = data.slice(0, 7).map(i => i.qty);
    const labels = data.slice(0, 7).map(i => i.dispatch_nature);

    GraphicUtils.barChart('dispatch-nature', values, labels, false, true, 3);
    data && data.length > 0 && ReportUtils.createExportableTable(labels, values, "Despachos por natureza");

  }, [data]);

  return (
    <>
      <div className="chart-report">
        <span className="chart-title">Despachos por natureza {data?.length >= 7 ? ' (TOP 7)' : ''}</span>
        <div className="mt-3" id="dispatch-nature"></div>
      </div>

      <div className="chart-divisor"></div>
    </>
  );
};

export default DispatchNatures;